'use strict';

const React = require('react');
const _ = {
    assign:     require('lodash/assign'),
    filter:     require('lodash/filter'),
    find:       require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    forEach:    require('lodash/forEach'),
    map:        require('lodash/map'),
    uniq:       require('lodash/uniq'),
};

const ShortCourseConstants = require('../../../../../app/shared/ShortCourseConstants');

const ShortCourseEditorActions = require('../../../actions/ShortCourseEditorActions');
const ShortCourseEditorStore = require('../../../stores/ShortCourseEditorStore');

class SearchSidebar extends React.Component {
    constructor(props) {
        super(props);

        const storeState = ShortCourseEditorStore.getState();
        const doc = storeState.shortCourseDoc; 
        const searchText = storeState.nodeSearchText || '';

        this.state = {
            doc,
            searchText,
            lastSearchText: searchText,
            navLocs: this.getMatchingLocations(doc, searchText),
        };
        this.unsubscribes = [
            ShortCourseEditorStore.listen(this.onStoreChange),
        ];
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    doSearchRichText=(richText,lowerCaseSearchText)=>{
        if (!richText) {
            return false;
        }
        var rt,txt;
        try {
            rt = $(`<div>${richText}</div>`); // construct html from string
            txt = rt.text(); // extract just the text
        }
        catch(e) {
            console.log("error in doSearchRichText",e); // FIXME: remove debug spam
            console.log("richText:",richText);
            txt = richText; // search without converting to html then text
        }
        if (txt) {
            var i = txt.toLowerCase().indexOf(lowerCaseSearchText);
            if (i >= 0) {
                return true;
            }
        }
        return false;
    } // doSearchRichText
    
    
    getMatchingLocations=(doc,searchText)=>{
        let matchingLocs = [];
        if (!doc || !searchText) {
            return matchingLocs;
        }
        var lc = searchText.toLowerCase();
        
        function doSearch(txt) {
            if (txt && (txt.toLowerCase().indexOf(lc) >= 0)) {
                return true;
            }
        }
        
        // search node name and description
        _.forEach(doc.nodes,(node)=>{
            if ( doSearch(node.name) || doSearch(node.description)) {
                matchingLocs.push({
                    type: ShortCourseConstants.NAV_TYPES.Node,
                    id: node.node_id,
                });
            }
        });
        
        // search subskills
        _.forEach(doc.subskills,(ss)=>{
            if (doSearch(ss.name) || doSearch(ss.description)) {
                _.forEach(ss.node_relations,(v,node_id)=>{
                    if (node_id) {
                        matchingLocs.push({
                            type: ShortCourseConstants.NAV_TYPES.Node,
                            id: node_id,
                        });
                    }
                });
            }
        });

        // search rich text
        _.forEach(doc.client_content.rich_texts,(richTextEntry)=>{
            if (this.doSearchRichText(richTextEntry.rich_text,lc)) {
                //console.log(`found search term in richTextEntry ${richTextEntry.id} ${richTextEntry.displayName}`);
                let rich_text_id = richTextEntry.id;
                let coachEntry;
                if (richTextEntry.coach_script_id) {
                    coachEntry = _.find(doc.client_content.coach_scripts,{id:richTextEntry.coach_script_id});
                    if (!coachEntry) {
                        console.log("ERROR: richTextEntry specifies unknown coach_script_id",richTextEntry);
                    }
                }
                if (coachEntry) {
                    let action_index = _.findIndex(coachEntry.actions,{rich_text_id});
                    matchingLocs.push({
                        type: ShortCourseConstants.NAV_TYPES.CoachScript,
                        id: richTextEntry.coach_script_id,
                        action_index,rich_text_id, // deeper navigation
                    });
                }
                else {
                    // common rich text element
                    matchingLocs.push({
                        type: ShortCourseConstants.NAV_TYPES.RichText,
                        id: rich_text_id,
                    });
                }
            }
        });
        
        // search coach entries
        _.forEach(doc.client_content.coach_scripts,(entry)=>{
            if (doSearch(entry.displayName)) {
                matchingLocs.push({
                    type: ShortCourseConstants.NAV_TYPES.CoachScript,
                    id: entry.id,
                });
            }
        });
        
        return _.uniq(matchingLocs);
    }
    
    onStoreChange=()=>{
        const storeState = ShortCourseEditorStore.getState();
        const doc = storeState.shortCourseDoc; 
        const searchText = storeState.nodeSearchText || '';
        
        this.setState({
            doc, searchText, 
            navLocs: this.getMatchingLocations(doc, this.state.searchText),
        });
    }
       
    goToNav=(nav)=>{
        if (nav) {
            ShortCourseEditorActions.goToLocation(nav);
        }
    }
    
    setSearchText=(evt)=>{
        this.setState({searchText: evt.target.value});
    }
    
    doSearch=()=>{
        const doc = this.state.doc;
        this.setState({
            lastSearchText: this.state.searchText,
            navLocs: this.getMatchingLocations(doc, this.state.searchText),
        });
        ShortCourseEditorActions.setNodeSearch(this.state.searchText);
    }
    
    handleKeyPress=(e)=>{
        if (e.key === 'Enter') {
            this.doSearch();
        }
    }
    
    renderSearchedText=(txt,k, extraClass, prefix, noDecode)=>{
        var elements=[];
        var srch = this.state.lastSearchText.toLowerCase();
        //if (!noDecode) {
        //    txt = SharedUtils.decodeProse(txt,this.state.variableTable);
        //}
        var lc = txt.toLowerCase();
        var sl = this.state.lastSearchText.length;
        var i = lc.indexOf(srch);
        if (prefix) {
            elements.push(<span key={k+'-prefix'} className="prefix">{prefix}</span>);
        }
        if (!sl || i<0) {
            elements.push(<span key={k} className="not-found">{txt}</span>);
        }
        else {
            var unprocessed = txt;
            while(i>=0) {
                var left = unprocessed.slice(0,i);
                var found = unprocessed.slice(i,i+sl);
                unprocessed = unprocessed.slice(i+sl);
                elements.push(<span key={elements.length} className="not-found">{left}</span>);
                elements.push(<span key={elements.length} className="found">{found}</span>);
                lc = unprocessed.toLowerCase();
                i = lc.indexOf(srch);
            }
            elements.push(<span key={elements.length} className="not-found">{unprocessed}</span>);
        }
        return (
            <div key={k} className={"searched-text " + (extraClass || '')}>
                {elements}
            </div>
        );
    }
    
    renderMatch=(navLoc,key)=>{
        const doc = this.state.doc;
        let headingText,gotoText;
        let node,richTextEntry,coachEntry;
        switch(navLoc.type) {
            //case ShortCourseConstants.NAV_TYPES.Settings:
            case ShortCourseConstants.NAV_TYPES.CoachScript:
                coachEntry = _.find(doc.client_content.coach_scripts,{id:navLoc.id});
                headingText = `Coach Script: ${coachEntry.displayName}`;
                if ((typeof navLoc.action_index === 'number') && (navLoc.action_index >= 0)) {
                    headingText += `, action ${navLoc.action_index+1}`;
                }
                gotoText = "Go To Script";
                richTextEntry = _.find(doc.client_content.rich_texts,{id:navLoc.rich_text_id});
                if (richTextEntry) {
                    gotoText = "Go To Rich Text";
                }
                break;
            case ShortCourseConstants.NAV_TYPES.Node:
                headingText = "Skill Node";
                gotoText = "Go To Node";
                node = _.find(doc.nodes,{node_id: navLoc.id});
                break;
            case ShortCourseConstants.NAV_TYPES.RichText:
                headingText = "Rich Text";
                gotoText = "Go To Rich Text";
                richTextEntry = _.find(doc.client_content.rich_texts,{id:navLoc.rich_text_id});
                break;
        }
        var textElements = [];
        if (node) {
            if (node.name) {
                textElements.push(this.renderSearchedText(node.name, textElements.length));
            }
            if (node.description) {
                textElements.push(this.renderSearchedText(node.description, textElements.length));
            }
        }
        if (richTextEntry) {
            let rt,txt;
            try {
                rt = $(`<div>${richTextEntry.rich_text}</div>`); // construct html from string
                txt = rt.text(); // extract just the text
                textElements.push(this.renderSearchedText(txt, textElements.length));
            }
            catch(e) {
                // do nothing
            }
        }
        return (
            <div className="search-node" key={key}>
                <h1>{headingText}</h1>
                {textElements}
                <br/>
                <button className={"nav"}
                    title={gotoText} aria-label={gotoText} 
                    onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('search-nav-button',evt)}*/}
                    onClick={(evt)=>{this.goToNav(navLoc,evt)}}>
                    {'goto'}
                </button>
            </div>
        )
    }

    render() {
        return (
            <div className="search-sidebar">
                <label className="sc-search-bar">{'Search:'}
                    <input type="text" value={this.state.searchText} onChange={this.setSearchText} onKeyPress={this.handleKeyPress}/>
                    {this.state.searchText !== this.state.lastSearchText ?
                    <button className="search-button" 
                        onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('search-button',evt)}*/}
                        onClick={this.doSearch}>
                        <i className="glyphicon glyphicon-search"/>
                    </button>
                    : null }
                </label>
                <div className="search-sidebar-content">
                    <div className="search-section">
                        {_.map(this.state.navLocs,(navLoc,key)=>{ return this.renderMatch(navLoc,key); })}
                    </div>
                </div>
            </div>
        )
    }
}; // SearchSidebar


module.exports = SearchSidebar;

